export default {
  'llm.callLogs.source': '执行来源',
  'llm.callLogs.officialSource': '官方服务',
  'llm.callLogs.tenantSource': '租户自有模型',
  'llm.callLogs.localSource': '本地其他服务',
  'llm.callLogs.syncPending':
    '官方数据尚未同步完成或暂不可用；以下为已保存记录',
  'llm.callLogs.lastSynced': '官方数据同步时间',
  'llm.callLogs.officialUnavailable': '官方正文暂不可用，请稍后重试',
  'llm.callLogs.app': '应用',
  'llm.callLogs.scene': '场景',
  'llm.callLogs.caller': '调用者',
  'llm.callLogs.resource': '资源标识',
  'llm.callLogs.running': '运行中',
  'llm.callLogs.cancelled': '已取消',
  'llm.callLogs.unknown': '结果未知',
  'llm.callLogs.notProvided': '未提供',
  'llm.callLogs.estimated': '估算',
  'llm.callLogs.serviceType': '服务类型',
  'llm.callLogs.actions': '操作',
  'llm.callLogs.details': '调用详情',
  'llm.callLogs.viewDetails': '查看详情',
  'llm.callLogs.detailFailed': '加载详情失败',
  'llm.callLogs.complete': '完整',
  'llm.callLogs.truncated': '已截断',
  'llm.callLogs.notCaptured': '未采集',
  'llm.callLogs.expired': '已过期',
  'llm.callLogs.expiredBody': '正文已超过 30 天保留期',
  'llm.callLogs.retry': '重试',
  'llm.callLogs.incomplete': '调用未完整结束，以下为已采集内容',
  'llm.callLogs.status': '状态',
  'llm.callLogs.entryPoint': '调用入口',
  'llm.callLogs.startedAt': '开始时间',
  'llm.callLogs.endedAt': '结束时间',
  'llm.callLogs.duration': '总耗时',
  'llm.callLogs.firstResponse': '首响应耗时',
  'llm.callLogs.upstreamId': '上游 Request ID',
  'llm.callLogs.streaming': '流式调用',
  'llm.callLogs.yes': '是',
  'llm.callLogs.no': '否',
  'llm.callLogs.requestBody': '请求正文',
  'llm.callLogs.responseBody': '响应正文',
  'llm.callLogs.usage': '用量与费用',
  'llm.callLogs.inputTokens': '输入 Token',
  'llm.callLogs.outputTokens': '输出 Token',
  'llm.callLogs.totalTokens': '总 Token',
  'llm.callLogs.cacheReadTokens': '缓存读取 Token',
  'llm.callLogs.cacheWriteTokens': '缓存写入 Token',
  'llm.callLogs.cacheWrite1hTokens': '1 小时缓存写入 Token',
  'llm.callLogs.reasoningTokens': '推理 Token',
  'llm.callLogs.usageSource': '用量来源',
  'llm.callLogs.meter': '计量',
  'llm.callLogs.cost': '费用',
  'llm.callLogs.settlement': '结算金额',
  'llm.callLogs.errorsAndAttempts': '错误与尝试',
  'llm.callLogs.errorCode': '错误码',
  'llm.callLogs.failedStage': '失败阶段',
  'llm.callLogs.errorMessage': '错误信息',
  'llm.callLogs.related': '关联调用',
  'llm.callLogs.modelService': '模型',
  'llm.callLogs.digitalHuman': '数字人',
  'llm.callLogs.loadFailed': '加载调用日志失败，请重试',
  'llm.callLogs.requestIdHint': '输入完整 Request ID，精确匹配',
  'llm.callLogs.scope': '查看范围',
  'llm.callLogs.modelCode': '输入模型编码',
  'llm.callLogs.sceneCode': '输入场景编码',
  'llm.callLogs.reset': '重置',
  'llm.callLogs.search': '查询',
  'llm.callLogs.collapse': '收起高级搜索',
  'llm.callLogs.advanced': '高级搜索',
  'llm.callLogs.retentionHint': '默认搜索全部保留日志；多个条件同时满足。',
  'pages.navigation.items.modelCallLogs': '平台调用日志',
  'llm.callLogs.officialLogs': '平台调用日志',
  'llm.callLogs.tenant': '租户',
  'llm.callLogs.refresh': '刷新',
  'pages.navigation.items.aiScenes': '应用场景',
  'pages.navigation.items.modelPolicies': '运行策略',
  'pages.navigation.items.modelCircuits': '熔断管理',

  'menu.centers.aiModels': 'AI模型',
  'pages.navigation.items.modelAccess': '模型接入',
  'pages.navigation.items.modelUsage': '平台整体用量',
  'pages.navigation.items.modelTenantUsage': '租户用量管理',

  'menu.centers.workspace': '首页',
  'menu.centers.applications': '应用',
  'menu.centers.capabilities': '服务',
  'menu.centers.markets': '市场',
  'menu.centers.resources': '运维',
  'menu.centers.commercial': '销售',
  'menu.centers.management': '租户',
  'menu.centers.settings': '设置',
  'menu.centers.resourceOverview': '资源概览',
  'pages.navigation.mainNavigation': '主导航',
  'pages.navigation.skipToContent': '跳到主要内容',
  'pages.navigation.resizeSidebar': '调整侧栏宽度',
  'pages.navigation.items.appMarket': '应用市场',
  'pages.navigation.items.skillMarketplace': 'Skill 市场',
  'pages.navigation.items.mcpMarketplace': 'MCP 市场',
  'pages.navigation.items.pluginMarketplace': '插件市场',
  'pages.navigation.items.workspaceOverview': '工作台概览',
  'pages.navigation.items.agentApps': '智能体管理',
  'pages.navigation.items.models': '模型广场',
  'pages.navigation.items.events': '事件引擎',
  'pages.navigation.items.mcp': 'MCP 服务',
  'pages.navigation.items.resourceOverview': '资源概览',
  'pages.navigation.items.clusters': '集群管理',
  'pages.navigation.items.storage': '应用存储',
  'pages.navigation.items.knowledge': '知识库',
  'pages.navigation.items.dataSources': '数据源',
  'pages.navigation.items.applicationManagement': '应用管理',
  'pages.navigation.items.applications': '业务应用',
  'pages.navigation.items.pluginApplications': '插件应用',
  'pages.navigation.items.applicationFeedback': '应用反馈',
  'pages.navigation.items.externalPublication': '外部应用上架',
  'pages.navigation.items.publicationReview': '应用上架审核',
  'pages.navigation.items.taxonomies': '分类法管理',
  'pages.navigation.items.aiServices': 'AI服务',
  'pages.navigation.items.digitalHumanMarket': '数字人',
  'pages.navigation.items.digitalHumanMarketplace': '数字人市场',
  'pages.navigation.items.mcpMarket': 'MCP',
  'pages.navigation.items.skillMarket': 'Skills',
  'pages.navigation.items.products': '统一商品目录',
  'pages.navigation.items.packages': '套餐管理',
  'pages.navigation.items.entitlements': '租户权益',
  'pages.navigation.items.platformTenants': '租户管理',
  'pages.navigation.items.platformUsers': '用户管理',
  'pages.navigation.items.platformPermissions': '平台权限',
  'pages.navigation.items.platformSettings': '平台设置',
  'pages.navigation.items.orders': '支付订单',
  'pages.navigation.items.members': '成员管理',
  'pages.navigation.items.departments': '部门管理',
  'pages.navigation.items.roles': '权限管理',
  'pages.navigation.items.auditLog': '审计日志',
  'menu.centers.appStore': '部署模板',
  'menu.centers.deployments': '我的部署',
  'pages.navigation.items.appStore': '部署模板',
  'pages.navigation.items.deployments': '我的部署',
  'menu.centers.images': '镜像仓库',
  'pages.navigation.items.images': '镜像仓库',
};
